import { darken } from 'polished';
import styled from 'styled-components';
// import backImage from './../../assets/textura-rede-social.png';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 202px;
  width: 100%;
  background: #e4e7ec;
  background-blend-mode: soft-light;
  filter: alpha(Opacity=90);
  gap: 42px;

  @media only screen and (max-width: 950px) {
    gap: 12px;
    height: 205px;
  }
  padding: 19px 35px;

  a {
    background: ${props => props.primaryColor || '#475467'};
    width: 280px;
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    text-decoration: none;
    :hover {
      background: ${props => darken(0.1, props.primaryColor || '#475467')};
    }
    color: #fff;

    @media only screen and (max-width: 950px) {
      width: 100%;
    }
  }
`;

export const Title = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 30px;
  color: #475467;
  @media only screen and (max-width: 950px) {
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 30px;
    text-align: center;
  }
`;
